import React, { useState, useEffect } from "react";
import "animate.css/animate.compat.css";
import SplashScreen from "./components/SplashScreen";
import Home from "./components/Home";
import About from "./components/About";
import Gallery from "./components/Gallery";
import Contact from "./components/Contact";
import ScrollTop from "./general/ScrollTop";
import Header from "./general/Header";
import Footer from "./general/Footer";
import Login from "./components/Login";
import AdminDashboard from "./components/AdminDashboard";
import PageNotFound from "./components/PageNotFound";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminHeader from "./components/AdminHeader";
import Copyright from "./general/Copyright";
import AdminEnquiry from "./components/AdminEnquiry";
import Booking from "./components/Booking";
import AdminBooking from "./components/AdminBooking";
import Mahakumbh from "./components/Mahakumbh";

const App = () => {
    const [vehicle, setVehicle] = useState([]);

  const [isSplash, setIsSplash] = useState(true);
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  // Hide splash screen after 3 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsSplash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);


  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const response = await fetch(
          "https://apis.anvifoundation.com/omanshi/get-vehicle"
        );
        const data = await response.json();

        if (response.ok) {
          setVehicle(data); // Store the fetched sites in state
        } else {
          console.error("Failed to fetch vehicles:", data);
        }
      } catch (error) {
        console.error("Error while fetching vehicles:", error);
      }
    };

    fetchVehicles();
  }, []); // Empty dependency array means it runs once when the component mounts

  return (
    <BrowserRouter>
      <ScrollTop />
      {isSplash ? (
        <SplashScreen />
      ) : (
        <>
          {!isLoggedIn && (
            <>
              <div className="main-content">
                <Header />
                <Routes>
                  <Route exact path="/" element={<Home />} />
                  <Route exact path="/about" element={<About />} />
                  <Route
                    exact
                    path="/destination-gallery"
                    element={<Gallery />}
                  />
                  <Route exact path="/tour-booking" element={<Booking vehicle={vehicle} />} />
                  <Route exact path="/contact" element={<Contact />} />
                  <Route exact path="/mahakumbh" element={<Mahakumbh />} />
                  <Route exact path="/login" element={<Login />} />
                  <Route exact path="*" element={<PageNotFound />} />
                </Routes>
              </div>
              <Footer />
            </>
          )}

          {isLoggedIn && (
            <>
              {/* <AdminHeader /> */}
              <div className="main-content">
                <AdminHeader />
                <Routes>
                  <Route exact path="/" element={<AdminDashboard />} />
                  <Route
                    exact
                    path="/admin/dashboard"
                    element={<AdminDashboard />}
                  />
                  <Route
                    exact
                    path="/admin/enquiry"
                    element={<AdminEnquiry />}
                  />
                  <Route
                    exact
                    path="/admin/bookings"
                    element={<AdminBooking />}
                  />
                  <Route exact path="*" element={<PageNotFound />} />
                </Routes>
              </div>
              <Copyright />
            </>
          )}
        </>
      )}
    </BrowserRouter>
  );
};

export default App;
